import { render } from "./showTotalCard.vue?vue&type=template&id=fd673f2a"
import script from "./showTotalCard.vue?vue&type=script&lang=js"
export * from "./showTotalCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__